export default __webpack_public_path__ + "static/media/66.4d04a2e2.jpeg";